import { ngettext } from '@sdk/lang/gettext';
import { BreakViolation } from '@sdk/automatedBreaks/types/BreakViolation';
import { AutomatedBreakType } from '@sdk/settings/types';

const getEndedToSoonMessage = (type: AutomatedBreakType, numberOfBreaks: number) => {
  if (type === AutomatedBreakType.meal) {
    return ngettext(
      '%(numberOfBreaks)s meal break ended too soon',
      '%(numberOfBreaks)s meal breaks ended too soon',
      numberOfBreaks,
      {
        numberOfBreaks,
      }
    );
  }

  return ngettext(
    '%(numberOfBreaks)s rest break ended too soon',
    '%(numberOfBreaks)s rest breaks ended too soon',
    numberOfBreaks,
    {
      numberOfBreaks,
    }
  );
};

export const getExcessiveMessage = (type: AutomatedBreakType, numberOfBreaks: number) => {
  if (type === AutomatedBreakType.meal) {
    return ngettext(
      '%(numberOfBreaks)s excessive meal break',
      '%(numberOfBreaks)s excessive meal breaks',
      numberOfBreaks,
      {
        numberOfBreaks,
      }
    );
  }

  return ngettext(
    '%(numberOfBreaks)s excessive rest break',
    '%(numberOfBreaks)s excessive rest breaks',
    numberOfBreaks,
    {
      numberOfBreaks,
    }
  );
};

const multipleBreaksViolationsToText = {
  [BreakViolation.endedTooSoon]: getEndedToSoonMessage,
};

export default multipleBreaksViolationsToText;
